import PromotionBanner from './promotionBanner/PromotionBanner';
import ServiceShortcut from './serviceShortcut/ServiceShortcut';
import NewsContent from './content/NewsContent';
import SectionContent from './content/SectionContent';
import NshopContent from './content/NshopContent';
import SpecialBanner from './specialBanner/SpecialBanner';
import EtcService from './content/Etcservice';
import TopCard from './content/TopCard';
import My from './my/My';
import Siege from './siege/Siege';
import {isDefined, isNotDefined, getFirstObjectHasProperty, namespace, parseInt10, not} from './../utils/util';
import { BREAKPOINTS, API_DOMAIN_DEFAULT, STATIC_DOMAIN_DEFAULT } from './../model/model';
import {getDatasWithOption} from "../utils/service";

(function ($, global) {
  "use strict";

  let promotionBanner = null,
    serviceShortcut = null,
    newsContent = null,
    topCard = null,
    sectionContent = null,
    nshopContent = null,
    specialBanner = null,
    mySection = null,
    siege = null,
    etcService = null;

  namespace('nc.lineage');

  nc.lineage.main = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.main require options object');

    let contiGroupData = {};
    contiGroupData.section = [];

    $(options.promotionBanner.wrap).append('<div class="loadingbar"></div>');
    $(options.sectionContent.wrap).append('<div class="loadingbar"></div>');


    init();

    function init() {
      getDatasWithOption([{
        type: 'GET',
        url: options.apiDomain +'/conti/getContentGroup?service=lineage&groupAlias=lineage-main&subAlias=ko-KR',
        dataType: 'json',
        contentType: 'application/json',
        Accept: 'application/json'
      }], (data) => {
        if(not(Array.isArray)(data) || data.length <= 0) {
          console.log( 'error : no data' );
        } else {
          data.forEach(item => {
            if(item.alias === 'main-shortcut') contiGroupData.shortcutWeb = JSON.parse(item.jsonData);
            if(item.alias === 'main-shortcut-ingame') contiGroupData.shortcutIngame = JSON.parse(item.jsonData);
            if(item.alias === 'main-news') contiGroupData.news = JSON.parse(item.jsonData);
            if(item.alias === 'main-topcard') contiGroupData.topcard = JSON.parse(item.jsonData);
            if(item.alias === 'main-nshop') contiGroupData.nshop = JSON.parse(item.jsonData);
            if(item.alias === 'main-siege') contiGroupData.siege = JSON.parse(item.jsonData);
            if(item.alias === 'main-promotion') contiGroupData.promotion = JSON.parse(item.jsonData);
            if(item.alias === 'main-etc') contiGroupData.etc = JSON.parse(item.jsonData);
            if(item.alias === 'main-special') contiGroupData.special = JSON.parse(item.jsonData);
            if(item.alias === 'main-section1') contiGroupData.section[1] = JSON.parse(item.jsonData);
            if(item.alias === 'main-section2') contiGroupData.section[2] = JSON.parse(item.jsonData);
            if(item.alias === 'main-section3') contiGroupData.section[3] = JSON.parse(item.jsonData);
            if(item.alias === 'main-section4') contiGroupData.section[4] = JSON.parse(item.jsonData);
            if(item.alias === 'main-section5') contiGroupData.section[5] = JSON.parse(item.jsonData);
            if(item.alias === 'main-section6') contiGroupData.section[6] = JSON.parse(item.jsonData);
          });
          // ingame 일 경우 숏컷 데이터가 다름
          contiGroupData.shortcut = options.isIngame ? contiGroupData.shortcutIngame : contiGroupData.shortcutWeb;
          setInstance();
        }
      }, (data) => {
        console.log( 'error : rejected' );
      });

    }

    function setInstance() {
      const option = $.extend(true, {
        apiDomain: API_DOMAIN_DEFAULT,
        staticDomain: STATIC_DOMAIN_DEFAULT,
        userData: null,

        promotionBanner: {
          wrap: null,
          rollingInterval: 5000,
          breakpoint: BREAKPOINTS,
          global: global,
          data : contiGroupData.promotion
        },

        serviceShortcut: {
          wrap: null,
          breakpoint: BREAKPOINTS,
          global: global,
          data : contiGroupData.shortcut
        },

        newsContent: {
          wrap: null,
          breakpoint: BREAKPOINTS,
          global: global,
          data : contiGroupData.news
        },

        topCard: {
          wrap: null,
          breakpoint: BREAKPOINTS,
          global: global,
          apiDomain: options.apiDomain,
          data : contiGroupData.topcard
        },

        sectionContent: {
          wrap: null,
          breakpoint: BREAKPOINTS,
          global: global,
          data : contiGroupData.section
        },

        nshopContent: {
          wrap: null,
          breakpoint: BREAKPOINTS,
          global: global,
          data : contiGroupData.nshop
        },

        specialBanner: {
          wrap: null,
          breakpoint: BREAKPOINTS,
          global: global,
          data : contiGroupData.special
        },

        my: {
          wrap: null,
          global: global
        },

        siege: {
          wrap: null,
          serverId: 1,
          global: global,
          data : contiGroupData.siege
        },

        etcService: {
          wrap: null,
          global: global,
          isIngame: options.isIngame,
          data : contiGroupData.etc
        }
      }, options);

      promotionBanner = new PromotionBanner(option.promotionBanner).init();
      serviceShortcut = new ServiceShortcut(option.serviceShortcut).init();
      newsContent = new NewsContent(option.newsContent).init();
      topCard = new TopCard(option.topCard).init();
      sectionContent = new SectionContent(option.sectionContent).init();
      nshopContent = new NshopContent(option.nshopContent).init();
      specialBanner = new SpecialBanner(option.specialBanner).init();
      etcService = new EtcService(option.etcService).init();

      mySection = new My({
        wrap: option.my.wrap,
        apiDomain: option.apiDomain,
        userData: option.userData,
        global: global
      }).init();

      siege = new Siege({
        wrap: option.siege.wrap,
        apiDomain: option.apiDomain,
        serverId: option.siege.serverId,
        data : contiGroupData.siege,
        global: global
      }).init();
    }




  };

  /*
   * external methods
   */
  global.changeSiegeResult = function (serverId) {
    if (isDefined(siege)) siege.changeSiegeResult(parseInt10(serverId));
  };
}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/main/main.2.js